import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=0f82a247&scoped=true&"
import script from "./Switcher.vue?vue&type=script&lang=js&"
export * from "./Switcher.vue?vue&type=script&lang=js&"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=0f82a247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f82a247",
  null
  
)

export default component.exports